// extracted by mini-css-extract-plugin
module.exports = {"crypto-pro-signature":"_2Nf-pM2W_AyhaB-W-DkelV","crypto-pro-signature__status":"_3o8N6H5HCwdUqEpebHrfHM","crypto-pro-signature__status_is-valid":"_1vOMBXDN3uA_1i1rZ9pR21"};